<div class="th-menulevel modal">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(2)">
    <span>{{ 'menus.edit' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-remove" (click)="selectMenu(1)">
    <span>{{ 'menus.delete' | translate }}</span>
  </div>
</div>
